const URLB = {
  URL_BACKEND: 'https://cris-api.ciu.nstu.ru'
}
export { URLB }

// 127.0.0.1:5000  http://127.0.0.1:5000 https://cris-api.ciu.nstu.ru
